import { gql } from '@apollo/client';

export const GET_CUSTOM_MERGE_FIELDS = gql`
    query GetCustomMergeFields($locationId: ID!, $templateType: BuildableTemplateType!) {
        location(id: $locationId) {
            id
            buildableTemplateCustomMergeFields(templateType: $templateType) {
                key
                value
            }
        }
    }
`;
